import FullCalendar from '@fullcalendar/react';
import listPlugin from '@fullcalendar/list';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import {
  CalendarMonth as CalendarMonthIcon,
  ViewWeek as ViewWeekIcon,
  ViewDay as ViewDayIcon,
  ViewAgenda as ViewAgendaIcon,
  SvgIconComponent,
} from '@mui/icons-material';

import {
  IScheduleShortEvent,
  SCHEDULE_TYPES,
} from '../../../store/V2/ScheduleSlice';
import { ZOOM_MEETING_REQUEST_STATUSES } from '../../../store/V2/ZoomRequestsSlice';

export type TCalendarViewOptions = {
  label: string;
  value: 'dayGridMonth' | 'timeGridWeek' | 'timeGridDay' | 'listWeek';
  icon: SvgIconComponent;
};

export const commonConfigs: FullCalendar['props'] = {
  headerToolbar: false,
  eventDisplay: 'block',
  allDayMaintainDuration: true,
  plugins: [listPlugin, dayGridPlugin, timeGridPlugin, momentTimezonePlugin],
  slotLabelFormat: {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  },
  eventTimeFormat: {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  },
};

export const calendarViewOptions: TCalendarViewOptions[] = [
  { value: 'dayGridMonth', label: 'Month', icon: CalendarMonthIcon },
  { value: 'timeGridWeek', label: 'Week', icon: ViewWeekIcon },
  { value: 'timeGridDay', label: 'Day', icon: ViewDayIcon },
  { value: 'listWeek', label: 'Agenda', icon: ViewAgendaIcon },
];

export const getEventTypeColors = (
  scheduleItem: IScheduleShortEvent
): { backgroundColor: string; textColor: string; borderColor: string } => {
  const colors = {
    backgroundColor: 'rgba(1, 167, 159, 0.3)',
    textColor: '#1E293B',
    borderColor: 'rgba(1, 167, 159, 0.3)',
  };

  switch (scheduleItem.type) {
    case SCHEDULE_TYPES.GROUP:
      colors.backgroundColor = '#cd4ce557';
      colors.textColor = '#7c3bc9';
      colors.borderColor = '#7c3bc9';
      break;

    default:
      break;
  }

  if (
    scheduleItem.zoomRequest &&
    scheduleItem.zoomRequest.status === ZOOM_MEETING_REQUEST_STATUSES.PENDING
  ) {
    colors.backgroundColor = '#FFF5CC';
    colors.textColor = '#B76E00';
    colors.borderColor = '#B76E00';
  }

  return colors;
};

export default commonConfigs;
